import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import './Login.css';

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [email, setEmail] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const emailFromURL = urlParams.get("email");

    if (!emailFromURL) {
      navigate("/Login");
    } else {
      setEmail(emailFromURL);
    }
  }, [location, navigate]);

  const handleResetPassword = (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setMessage("❌ Passwords do not match.");
      setIsSuccess(false);
      return;
    }

    try {
      let user = JSON.parse(localStorage.getItem(email));
      if (user) {
        user.password = newPassword;
        localStorage.setItem(email, JSON.stringify(user));
        setMessage("✅ Password has been updated successfully.");
        setIsSuccess(true);

        setTimeout(() => {
          navigate("/Login");
        }, 2000);
      } else {
        setMessage("❌ User not found.");
        setIsSuccess(false);
      }
    } catch (error) {
      setMessage("❌ Error updating password.");
      setIsSuccess(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="login-page d-flex justify-content-center align-items-center min-vh-100">
        <div className="login-container p-5 shadow-lg rounded-4 bg-light" style={{ width: "100%", maxWidth: "420px" }}>
          <h1 className="fs-3 text-center text-warning fw-bold mb-4">Reset Password</h1>

          {message && (
            <div className={`alert ${isSuccess ? "alert-success" : "alert-danger"} text-center`} role="alert">
              {message}
            </div>
          )}

          <form onSubmit={handleResetPassword}>
            <div className="mb-3">
              <label className="form-label text-dark fw-semibold">New Password:</label>
              <input
                type="password"
                className="form-control border-2 border-warning rounded-pill"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label text-dark fw-semibold">Confirm Password:</label>
              <input
                type="password"
                className="form-control border-2 border-warning rounded-pill"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-warning w-100 py-2 fw-semibold rounded-pill">
              Reset Password
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
